export default "__VITE_ASSET__C0b4nHuN__"